<template>
  <teleport
    to="body"
    :disabled="disableTeleport"
  >
    <div v-if="visible">
      <div class="modal-backdrop fade show" />
      <div
        :id="id || undefined"
        class="modal fade show d-block"
        :class="modalClass"
        tabindex="-1"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="ariaLabelledby || undefined"
        :aria-describedby="ariaDescribedby || undefined"
        @click.self="hide"
      >
        <div
          :class="dialogClasses"
          role="document"
        >
          <div class="modal-content">
            <slot :hide="hide" />
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'BaseModalShell',
  props: {
    ariaLabelledby: {
      type: String,
      default: '',
    },
    ariaDescribedby: {
      type: String,
      default: '',
    },
    centered: {
      type: Boolean,
      default: true,
    },
    dialogClass: {
      type: [String, Array, Object],
      default: '',
    },
    disableTeleport: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    modalClass: {
      type: [String, Array, Object],
      default: '',
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['hidden'],
  setup(props, { emit }) {
    const dialogClasses = computed(() => [
      'modal-dialog',
      props.size ? `modal-${props.size}` : '',
      props.scrollable ? 'modal-dialog-scrollable' : '',
      props.centered ? 'modal-dialog-centered' : '',
      props.dialogClass,
    ].filter(Boolean))

    const hide = () => {
      emit('hidden')
    }

    return {
      dialogClasses,
      hide,
    }
  },
})
</script>
